import styled from "styled-components";
import { Button } from "antd";
import AntSteps from "uiKits/Steps";
import background from "@/assets/Images/signUp.png";
import { media } from "@/theme/breakpoints";

export const BackgroundImage = styled.div`
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow-x: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const InnerContainer = styled.div`
  margin: 4.06rem 0rem;
  width: 60%;
  max-width: 100%;
  background: #ffffff;
  padding: 3.56rem 9.12rem;
  box-sizing: border-box;

  ${media.downTablet`
    margin: 0;
    width: 100%;
    padding: 3.56rem 2.12rem;
  `}

  ${media.downMobile`
    padding: 2rem 16px;
  `}
`;

export const StyledSteps = styled(AntSteps)`
  width: 50%;

  .ant-steps-item:not(.ant-steps-item-disabled) .ant-steps-item-container {
    cursor: pointer;
  }

  ${media.downTablet`
    width: 50%;
    display: flex;
    justify-content: center;
  `}

  ${media.downMobile`
    width: 100%;
  `}
`;

export const StepButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 7.75rem;
  max-width: 34.1875rem;
  margin-left: auto;
  margin-right: auto;

  ${media.downMobile`
    margin-top: 2.31rem;
    flex-direction: column-reverse;
  `}
`;

export const BackButton = styled(Button)`
  min-height: 44px;
  height: 3rem;
  min-width: 8rem;
  border-color: #ed6928;
  color: #ed6928;

  &:hover {
    color: #ed6928 !important;
    border-color: #ed6928 !important;
  }

  ${media.downMobile`
    width: 100%;
  `}
`;

export const StepsTitle = styled.p`
  margin: 0;
  color: #b5b5b5;
  font-family: Inter;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 1rem;
  `}
`;
